var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5645 0C26.485 0 12.5898 13.8951 12.5898 30.9745C12.5898 52.1705 40.3091 83.2874 41.4893 84.6017C42.5978 85.8363 44.5332 85.8342 45.6397 84.6017C46.8199 83.2874 74.5391 52.1705 74.5391 30.9745C74.5388 13.8951 60.6438 0 43.5645 0ZM43.5645 78.4658C34.2355 67.3844 18.1678 45.5217 18.1678 30.9748C18.1678 16.9708 29.5606 5.57796 43.5645 5.57796C57.5684 5.57796 68.9612 16.9708 68.9612 30.9746C68.961 45.5222 52.8958 67.3809 43.5645 78.4658Z",
    fill: "#3D3D3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5654 15.3906C34.9723 15.3906 27.9814 22.3816 27.9814 30.9747C27.9814 39.5679 34.9724 46.5589 43.5654 46.5589C52.1584 46.5589 59.1492 39.5679 59.1492 30.9747C59.1492 22.3816 52.1584 15.3906 43.5654 15.3906ZM43.5654 40.9809C38.0479 40.9809 33.5594 36.4922 33.5594 30.9747C33.5594 25.4573 38.0481 20.9686 43.5654 20.9686C49.0827 20.9686 53.5714 25.4573 53.5714 30.9747C53.5714 36.4922 49.0827 40.9809 43.5654 40.9809Z",
    fill: "#3D3D3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.527,
    height: 85.527,
    fill: "white",
    transform: "translate(0.800781)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.ebe2aa5697a6c2320cc2a4357770671f.svg";
export { ForwardRef as ReactComponent };